import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://20732ea19b730d0526d37384e267457d@o4511236225892353.ingest.de.sentry.io/4511236255580240",
  environment: "production",
  tracesSampleRate: 0.2,
});
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ThemeProvider } from './theme/ThemeContext';
import { ThemeProvider as ThemeMuiProvider } from '@mui/material/styles';
import { themeMui } from './theme/tribeTheme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeMuiProvider theme={themeMui}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </ThemeMuiProvider>
    </Provider>
  </React.StrictMode>
);
